import toast from "react-hot-toast";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewExperienceCenterList = (experienceCenterData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_EXPERIENCE_CENTER_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/experience-center/list`,
        experienceCenterData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_EXPERIENCE_CENTER_LIST_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "GET_EXPERIENCE_CENTER_LIST_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "GET_EXPERIENCE_CENTER_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewExperienceCenter = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_EXPERIENCE_CENTER_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/experience-center/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_EXPERIENCE_CENTER_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "GET_EXPERIENCE_CENTER_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "GET_EXPERIENCE_CENTER_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewExperienceCenter = (experienceCenterData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_NEW_EXPERIENCE_CENTER_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/experience-center/add`,
        experienceCenterData,
        config
      );

      dispatch({
        type: "ADD_NEW_EXPERIENCE_CENTER_SUCCESS",
        payload: data,
      });

      return { statusCode: data.statusCode };
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error.message ||
        "Failed to add experience center";

      dispatch({
        type: "ADD_NEW_EXPERIENCE_CENTER_FAILED",
        payload: errorMessage,
      });

      throw error;
    }
  };
};

export const updateExperienceCenter = (id, payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_EXPERIENCE_CENTER_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/experience-center/update`,
        {
          id: id,
          ...payload,
        },
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "UPDATE_EXPERIENCE_CENTER_SUCCESS",
          payload: data,
        });
        // toast.success("Updated Successfully!!");
        return data;
      } else {
        dispatch({
          type: "UPDATE_EXPERIENCE_CENTER_FAILED",
          payload: data,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_EXPERIENCE_CENTER_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};

export const changeExperienceCenterStatus = (experienceCenterData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "CHANGE_EXPERIENCE_CENTER_STATUS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/experience-center/update-status`,
        experienceCenterData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "CHANGE_EXPERIENCE_CENTER_STATUS_SUCCESS",
          payload: data,
        });
        toast.success("Changed Successfully!!");
        return data;
      } else {
        dispatch({
          type: "CHANGE_EXPERIENCE_CENTER_STATUS_FAILED",
          payload: data,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "CHANGE_EXPERIENCE_CENTER_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};


export const viewExperienceCenterFormList = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_EXPERIENCE_CENTER_FORM_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/experience-center-form/list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_EXPERIENCE_CENTER_FORM_LIST_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "GET_EXPERIENCE_CENTER_FORM_LIST_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "GET_EXPERIENCE_CENTER_FORM_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewExperienceCenterForm = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_EXPERIENCE_CENTER_FORM_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/experience-center-form/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_EXPERIENCE_CENTER_FORM_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "GET_EXPERIENCE_CENTER_FORM_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "GET_EXPERIENCE_CENTER_FORM_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const changeExperienceCenterFormStatus = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "CHANGE_EXPERIENCE_CENTER_FORM_STATUS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/experience-center-form/update-status`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "CHANGE_EXPERIENCE_CENTER_FORM_STATUS_SUCCESS",
          payload: data,
        });
        toast.success("Changed Successfully!!");
        return data;
      } else {
        dispatch({
          type: "CHANGE_EXPERIENCE_CENTER_FORM_STATUS_FAILED",
          payload: data,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "CHANGE_EXPERIENCE_CENTER_FORM_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};